// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"ffe71cb3","239":"dac06248","263":"10832d7a","453":"f88409ed","455":"7ac8d574","471":"da022dff","529":"eb688aa4","581":"a54c9df1","758":"fa1e08d6","821":"e98d73ce","977":"e9d662d1"}[chunkId] + ".chunk.js";
};